var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRoboCombustible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#040006;}.cls-3{fill:#562c14;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-robo-combustible") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_23",
    "data-name": 23
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.66,62.27c27,0,49,25,49,55.64s-22,55.64-49,55.64-49-25-49-55.64,22-55.64,49-55.64m0-6.68C80.9,55.59,56,83.49,56,117.91s24.94,62.32,55.7,62.32,55.71-27.9,55.71-62.32-24.94-62.32-55.71-62.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.45,83.1h92.42s-14.35-27.51-46.21-27.51S65.45,83.1,65.45,83.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.1,116.9a4.64,4.64,0,0,1,.82-.39c4-.8,7.12-3.48,10.17-6.28,1.14-1,1.29-2.06,0-3.13-1.69-1.47-3.29-3.09-5.09-4.37a15.75,15.75,0,0,0-12.14-2.84,24.18,24.18,0,0,0-10.54,4.89,48.67,48.67,0,0,0-2.17-7.71c-3.23-.19-9.73.48-12.48-1.11-5.29-3.07-10.9-2.6-16.45-.95-3.92,1.17-7.81,2.5-11.67,3.93a38,38,0,0,1-24.8.58c-6.46-1.93-13-3.53-19.6-4.85-3.83-.76-7.64.2-11.32,1.82-1.5.66-6.41.55-8.83.9,0,0-5.72,16.94-2,33.07.62.45,5.91.72,6.37,1.32,6.92,9.27,16.06,13.07,26.55,13.33,4.39.11,8-2.12,10.86-5.76,1.8-2.26,3.54-4.61,5.51-6.68,3.5-3.67,6-3.67,9.55,0,2,2.06,3.75,4.38,5.55,6.64,4.53,5.68,9.88,7.75,16.42,4.8,4.39-2,8.94-3.63,13.12-6.05,2.95-1.7,5.39-4.48,8.11-6.7.57-.47,6.41-.6,7.1-.88a55.17,55.17,0,0,0,.92-6.12c1.48,1.8,2.82,3.67,5.5,2.11,7.84,12.23,20.68,10.85,26.86,6.87C193.49,128.51,187.42,123.88,183.1,116.9Zm-106.82-.31c6.07-8.55,18.24-8.32,24.57.36C95.52,126,83.09,125.87,76.28,116.59Zm45.32.69c5.05-8.79,17.92-9.36,24.31-1.18C140.51,125.79,128.18,126.45,121.6,117.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoboCombustible);
export default __webpack_public_path__ + "static/media/ic-robo-combustible.5cbe644ed2da0d58dc0096044ffab719.svg";
export { ForwardRef as ReactComponent };